import { PlayCircle, Globe, BadgeAlert } from "lucide-react";

const targets = [
  {
    name: "example.com",
    status: "Completed",
    lastScan: "2025-07-26",
    alerts: 5,
    safe: false
  },
  {
    name: "shopdemo.site",
    status: "Completed",
    lastScan: "2025-07-20",
    alerts: 0,
    safe: true
  },
  {
    name: "legacyapp.net",
    status: "Pending",
    lastScan: "2025-07-30",
    alerts: 2,
    safe: false
  },
];

export default function TargetList() {
  return (
    <div className="bg-card rounded-xl p-6 mt-8 border border-border shadow w-full">
      <div className="flex items-center justify-between mb-3">
        <div className="font-semibold text-lg">Targets</div>
        <button className="flex items-center gap-2 bg-primary text-primary-foreground px-4 py-2 rounded-md hover:bg-primary/90 shadow transition">
          <PlayCircle size={20} />
          <span>New Scan</span>
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="text-muted-foreground font-semibold border-b">
            <tr>
              <th className="py-2 px-2 text-left font-normal">Website</th>
              <th className="py-2 px-2 text-left font-normal">Last Scan</th>
              <th className="py-2 px-2 text-left font-normal">Status</th>
              <th className="py-2 px-2 text-left font-normal">Alerts</th>
              <th className="py-2 px-2"></th>
            </tr>
          </thead>
          <tbody>
            {targets.map(t => (
              <tr key={t.name} className="border-b last:border-0">
                <td className="py-3 px-2 flex items-center gap-2 font-medium text-foreground">
                  <Globe size={16} className="opacity-80" />
                  {t.name}
                </td>
                <td className="py-3 px-2">{t.lastScan}</td>
                <td className={`py-3 px-2 font-semibold ${t.status === "Completed" ? "text-green-600 dark:text-green-400" : "text-yellow-500 dark:text-yellow-300"}`}>{t.status}</td>
                <td className="py-3 px-2 flex gap-1 items-center">
                  {t.alerts > 0 ? (
                    <span className="flex gap-1 items-center text-destructive"><BadgeAlert size={14} />{t.alerts}</span>
                  ) : (
                    <span className="text-green-600">0</span>
                  )}
                </td>
                <td className="py-3 px-2">
                  <button
                    className="bg-muted px-3 py-1 rounded hover:bg-accent font-medium text-xs text-muted-foreground transition"
                  >
                    Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
